import { render, staticRenderFns } from "./AcuteAppendicitisScore.vue?vue&type=template&id=bfa1ff5e&scoped=true&"
import script from "./AcuteAppendicitisScore.vue?vue&type=script&lang=js&"
export * from "./AcuteAppendicitisScore.vue?vue&type=script&lang=js&"
import style0 from "./AcuteAppendicitisScore.vue?vue&type=style&index=0&id=bfa1ff5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa1ff5e",
  null
  
)

export default component.exports